import styled from 'styled-components';

export const PartnerSectionContent = styled.div`
  .partners-network {
    padding: 5rem;

    h2 {
      text-align: center;
      margin-bottom: 60px;
      color: #c40023;
      font-size: 1.875rem;
    }
  }

  .partners-box {
    display: flex;
    align-items: center;

    .control-box {
      position: absolute;
      z-index: 999;

      &.left {
        left: -53px;
      }

      &.right {
        right: -53px;
      }
    }
  }

  .arrow-box {
    background: #C40023;
    font-size: 1.5rem;
    display: flex;
    height: 57px;
    width: 54px;
    margin: auto;

    svg {
      color: #ffffff;
      margin: auto;
    }

    &:hover {
      cursor: pointer;
      transition: 0.5s;
    }
  }

  .logo-box {
    background-color: #fff;
    padding: 12px;
    margin: 17px;
    width: 186px;
    text-align: center;
    height: 186px;
    position: relative;
    box-shadow: 0 0 20px #0000001a;
  }

  .category-control {
    text-align: center;
    padding: 0.5rem;

    p {
      font-weight: 700;
      margin-bottom: 10px;
      color: #666765;
    }

    span {
      color: #666765;
    }

    &.is-active {
      p {
        color: #c40023;
      }

      span {
        color: #000000;
      }

      border-bottom: 0.15rem solid #adacae;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .categories-row {
    display: flex;
    flex-flow: row wrap;
    align-content: space-between;
    justify-content: center;

    svg {
      font-size: 1.8rem;
      color: #e6e6e6;
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
    }

    .is-flex {
      align-items: center;
    }
  }

  .logos-row {
    display: -webkit-box;
    scroll-behavior: smooth;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media (min-width: 1408px) {
    .logos-row {
      width: 84%;
    }

    .partners-box {
      .control-box {
        position: relative;

        &.left,
        &.right {
          left: 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .partners-network {
      padding: 3.3rem 1rem;

      h2 {
        margin-bottom: 30px;
      }

      .control-box {
        display: none;
      }
    }

    .partners-box {
      padding: 0;
    }

    .logo-box {
      box-shadow: 0px 0px 14px #0000001a;
    }

    .categories-row {
      display: flex !important;
      justify-content: flex-start;
      flex-flow: row;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none;
      }

      .is-flex {
        min-width: 190px;
        justify-content: space-evenly;
      }
    }

    .logo-box {
      padding: 6px;
      margin: 10px;
      width: 121px;
      height: 121px;
      margin-bottom: 25px;
      display: flex;
      align-items: center;

      .logo {
        width: 100% !important;
        height: 100% !important;
      }
    }

    .logos-row {
      &::-webkit-scrollbar {
        display: block;
        width: 3px;
        height: 3px;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 2px grey;
        border-radius: 40px;
      }

      &::-webkit-scrollbar-thumb {
        background: #008ab5;
      }
    }
  }
`;
